import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '50vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.brightSmiles-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Header Styles */
    '& .header-wrapper': {
      background: palette.background.main,
      '& .menu-item, .header-phone-link': {
        color: palette.text.highlight,
      },
      '& .mobile-menu-icon': {
        color: palette.text.highlight,
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,
      marginTop: '54px',

      '@media (min-width:1281px)': {
        '& .hero-title, .hero-subtitle': {
          paddingBottom: 20
        },
        '& .image': {
          marginTop: 60,
          height: 580,
          width: 580
        }
      },

      '@media(min-width: 1200px)': {
        '& .hero-left-section': {
          paddingTop: 150
        }
      },

      '@media(min-width: 768px) and (max-width: 1023px)': {
        '& .image-wrapper': {
          display: 'flex',
          justifyContent: 'center',
          '& .image': {
            maxWidth: '100% !important'
          },
        },
      },

      '@media(min-width: 1024px) and (max-width: 1366px)': {
        '& .image': {
          height: '500px',
          width: '500px',
        },
        '& .section-alternate__content': {
          padding: '50px 0px',
        },
      },

      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper, & .section-header__cta-container':
        {
          '& .hero-title': {
            fontWeight: 600,
            color: palette.text.highlight,
            maxWidth: 500,
            paddingBottom: 10,
          },
          '& .hero-subtitle': {
            fontWeight: 400,
            color: palette.text.highlight,
            maxWidth: 480,
            lineHeight: '32px',
          },
          '@media screen and (max-width: 900px)': {
            '& .hero-title, & .hero-subtitle': {
              color: palette.text.highlight,
            },
          },
        },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '800px',
        '@media screen and (max-width: 900px)': { 
          maxHeight: '994px',
        },
        '& .MuiSelect-outlined': {
          background: palette.primary.main,
          color: palette.text.highlight,
          borderRadius: '10px',
        },
      },

      '& .login-button': {
        padding: '12px 42px',
      },

      '& .home-hero-title': {
        maxWidth: 600,

        '@media(min-width: 900px)': {
          lineHeight: 1.375,
        },

        '@media screen and (max-width: 900px)': {
          paddingTop: '32px',
        },
      },
      '& .home-hero-title, & .home-hero-subtitle': {
        fontSize: '2.0243rem',
        color: palette.text.highlight,
      },

      '@media(max-width: 900px)': {
        '& .section-header__cta-item-wrapper': {
          display: 'flex',
          width: '100%',
          '& .primary-button, .secondary-button': {
            width: '50%',
            marginRight: '10px',
          },
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 5px',
        '& .section-header__title-wrapper': {
          paddingBottom: 60,
        },
        '& .section-header__title': {
          fontSize: '2.5rem',
        },
        '& .definition-service-description': {
          fontSize: '1.125rem',
          lineHeight: '26px',
        },
        '@media screen and (max-width: 900px)': {
          '& .section-header__title': {
            fontSize: '2rem',
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.level3,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .highlight-divider': {
            background: palette.text.border,
          },
          '&:hover': {
            background: palette.text.highlight,
            color: palette.text.primary,
          },
          '& .price-value': {
            fontSize: 40,
          },
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
          borderTop: `1px solid ${palette.secondary.main}`,
        },

        '& .subscription-section': {
          '& .section-header__title, & .section-header__subtitle, & .subscription-tabs-label, & .summary-text, & .summary-subtext':
            {
              color: palette.text.highlight,
            },

          '@media(min-width: 900px)': {
            marginTop: 10,
            borderTop: `1px solid ${palette.secondary.main}`,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 550,
      },
      '& .step-counter': {
        color: palette.text.highlight,
        backgroundColor: palette.secondary.main,
        fontSize: 16,
      },

      '@media(min-width: 1024px) and (max-width: 1366px)': {
        '& .howitworks-wrapper': {
          padding: '0 !important'
        }
      },
        
      '@media screen and (min-width: 1200px)': { 
        '& .step-content': {
          maxWidth: 500,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-header': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        '& .contact-title, & .contact-subtitle': {
          color: palette.text.highlight,
        },
        background: palette.primary.main,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .faq-hero-section, & .checkout-hero-section':
      {
        marginTop: '54px',
        '& .hero-header-title, & .hero-header-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
        background: palette.background.main,
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.primary.main,
      },
      '& .section-header__title, .section-header__subtitle': {
        color: palette.text.highlight,
      },
      '& .primary-static-button': {
        color: palette.text.primary,
        backgroundColor: palette.text.highlight,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.light,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '& .testimonial-container': {
        justifyContent: 'center',
        '& .testimonial-name': {
          textAlign: 'center'
        }
      },
      '& .section-header__title, & .section-header__subtitle, & .patient-label':
        {
          color: palette.text.primary,
        },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiRating-readOnly': {
        display: 'flex',
        justifyContent: 'center'
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .custom-avatar': {
        display: 'none',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.background.arrow,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100,
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        color: palette.text.highlight,
        textAlign: 'center',
      },
      '& .header-container': {
        justifyContent: 'center',
      },

      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.light,
      },
      '& .faq-link': {
        fontWeight: 500,
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.primary.main,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title, & .contact-card-subtitle, & .provider-contact-details':
          {
            color: palette.text.highlight,
          },
        '& .provider-contact-link': {
          color: palette.text.highlight,
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.text.primary,
        },
      },
    },

    /* Find Provider Section */
    '& .stepperContainer': {
      '& .MuiStepConnector-line': {
        borderColor: palette.primary.main
      }
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .section-header__title, & .section-header__subtitle': {
          color: palette.text.highlight,
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /*Dashboard - styles */
    '& .benefits-widget': {
      '& .MuiTableCell-head': {
        color: `${palette.text.highlight} !important`,
      },
    },
  },
};